/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // From https://github.com/estrattonbailey/klaviyo-subscribe/blob/master/index.js
  async function klaviyoSubscribe (listId, email, params = {}) {
    console.log("klaviyoSubscribe", { listId, email, params });

    const config = Object.assign({}, params, {
      g: listId,
      email
    });

    const body = Object.keys(config).reduce((str, key) => {
      str.append(key, config[key])
      return str
    }, new URLSearchParams());

    console.log("klaviyoSubscribe", "requesting subscribe", { body });

    const res = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
      },
      body
    });
    
    const resJson = await res.json();
    console.log("klaviyoSubscribe", "result", { res, resJson });
    return resJson;
  }

  // https://www.klaviyo.com/docs/javascript-api#identify_section
  function klaviyoIdentify(data) {
    console.log("klaviyoIdentify", { data });
    window._learnq = window._learnq || [];
    window._learnq.push(['identify', data]);
  }

  q3 = window.q3 || {};

  function findYourElement(birthMoment) {
    if (!birthMoment.isValid()) throw new Error("Invalid birthMoment");
    const elementSlugs = ['yang-wood', 'yin-wood', 'yang-fire', 'yin-fire', 'yang-earth', 'yin-earth', 'yang-metal', 'yin-metal', 'yang-water', 'yin-water'];
    const elementNames = ['yang wood', 'yin wood', 'yang fire', 'yin fire', 'yang earth', 'yin earth', 'yang metal', 'yin metal', 'yang water', 'yin water'];
  
    // The original code had a bug where this was defined as moment("1900") without a format string, so it converted to UTC and then back to local, 
    //  which provides a different end result depending on where you complete this. Users now expect these bugged results.
    // So we specifically request 1990 as UTC to mirror that bug, but atleast avoid the deprecation warning for excluding the format string.
    //const startOf20thCentury = moment("1900 Z", "YYYY Z").startOf('day');
  
    // Actually, they decided to finally fix this bug. Keeping the above for posterity.
    let startOf20thCentury = moment("1900", "YYYY").startOf('day');
    
    // ACTUALLY, they want us to shift the results up one day on the EU site alone so some people (those to right of UTC line) still get the results they're used to
    startOf20thCentury = startOf20thCentury.subtract(1, "days");
  
    const daysBetweenStartOf20thAndBirth = birthMoment.diff(startOf20thCentury, 'days');
    const elementIndex = (daysBetweenStartOf20thAndBirth - 1) % 10;
    console.log("findYourElement", { birthMoment: birthMoment.format(), startOf20thCentury: startOf20thCentury.format(), daysBetweenStartOf20thAndBirth, elementIndex });
    return { 
      'slug': elementSlugs[elementIndex],
      'name': elementNames[elementIndex]
    };
  }

  q3.tabContainer = function () {
    // Tab container where you must have exactly one tab open
    const container = $(this);
    const tabs = container.find("[data-q3-tab]");
    const togglers = container.find("[data-q3-tab-toggle]");

    togglers.click(function() {
      const toggler = $(this);
      const togglerTabId = toggler.data("q3-tab-toggle");
  
      tabs.each(function () {
        const tab = $(this);
        const tabTabId = tab.data("q3-tab");
        
        if (tabTabId == togglerTabId) {
          tab.addClass("show");
        } else {
          tab.removeClass("show");
        }
      });
  
      togglers.removeClass("active");
      toggler.addClass("active");
    });
  }

  q3.selectsTime = function () {
    const el = $(this);
    const form = el.parents("form").first();
    const input = form.find("[data-q3-selects-time-dest]");
    const vals = {
      month: "",
      day: "",
      year: "",
      hour: "",
      minute: "",
      ampm: ""
    };
  
    const updateInput = function() {
      const timeStr = `${vals.year}-${vals.month}-${vals.day} ${vals.hour}:${vals.minute} ${vals.ampm}`;
      const timeMmt = moment(timeStr, 'YYYY-MM-DD hh:mm:ss a');
      input.val(timeMmt.format());
    }
    
    Object.keys(vals).forEach(function(key) {
      const select = el.find(`[data-q3-selects-time-${key}]`);
      vals[key] = select.val();
      select.change(function () {
        vals[key] = $(this).val();
        updateInput();
      });
    });
  
  }

  q3.quiz = function() {
    const quizEl = $(this);
    const quizForm = quizEl.find("form");
    const btnBack = quizEl.find(".quiz-back-btn");
    const btnNext = quizEl.find("[data-quiz-btn-next]");
    const btnStart = quizEl.find(".quiz-start-btn");
    
    btnBack.click(function() {
      const curStep = parseInt(quizEl.attr("data-q3-quiz-current-step"), 10);
      const prevStep = curStep - 1;
      //console.log("q3.quizInit", "btnBack.click", { curStep, prevStep });
      quizEl.attr('data-q3-quiz-current-step', prevStep);
    });
    
    btnNext.click(function() {
      const curStep = parseInt(quizEl.attr("data-q3-quiz-current-step"), 10);
      const nextStep = curStep + 1;
      //console.log("q3.quizInit", "btnNext.click", { curStep, nextStep });
      
      //validate
      const curStepEl = quizEl.find(`[data-quiz-step="${curStep}"]`);
      const requiredInputs = curStepEl.find("input[required]");
      //console.log("q3.quiz", "btnNext.click", { curStepEl, requiredInputs });
  
      const requiredErrors = requiredInputs.map(function() {
        const el = $(this);
        const validate = el.data("q3-required-valid");
        const group = el.parent(".q3-form-group").first();
        const msgEl = group.find(".q3-validation-msg");
        console.log("q3.quiz", "btnNext.click", "requiredInputs.map", { el, group, msgEl, validate });
  
        if (this.value) {
          if (!validate || this.value != "Invalid date") {
            group.removeClass("error");
            msgEl.empty();
            return false;
          } else {
            group.addClass("error");
            msgEl.text(q3.i18n.validation_msgs.invalid);
            return true;
          }
        } else {
          group.addClass("error");
          msgEl.text(q3.i18n.validation_msgs.required);
          return true;
        }
      }).get().some(x => !!x);
  
      if (requiredErrors) {
      } else {
        quizEl.attr("data-q3-quiz-current-step", nextStep);
      }
  
      return true;
    });
    
    btnStart.click(function() {
      const curStep = parseInt(quizEl.attr("data-q3-quiz-current-step"), 10);
      const nextStep = curStep + 1;
      //console.log("q3.quizInit", "btnStart.click", { curStep, nextStep });
      quizEl.attr('data-q3-quiz-current-step', nextStep);
    });
    
    quizForm.submit(function(event) {
      event.preventDefault();
  
      const { elements } = event.target;
      const birthDateStr = elements["birth-date"].value;
      //const birthDateDst = elements["birth-date-dst"].checked;
      const birthDateTimeUnknown = elements["birth-date-time-unknown"].checked;
      const birthPlaceCityState = elements["birth-place-city-state"].value;
      const birthPlaceCountry = elements["birth-place-country"].value;
      const email = elements["email"].value;
      const emailOptIn = elements["email-opt-in"].checked;
      const firstName = elements["first-name"].value;
      const lastName = elements["last-name"].value;
      //console.log("q3.quizForm.submit", { event, birthDateStr, birthPlaceCityState, birthPlaceCountry, birthDateTimeUnknown, email, emailOptIn, firstName, lastName });
  
      const birthDateMoment = moment(birthDateStr);
      const fye = findYourElement(birthDateMoment);
  
      if (email != "") {
        klaviyoIdentify({
          'Element': fye.name,
          '$email': email,
          '$first_name': firstName,
          '$last_name': lastName,
          '$source': 'Element Quiz Form',
          'Language': q3.i18n.locale_name,
          'Accepts Marketing': emailOptIn,
          'country': birthPlaceCountry,
          'city': birthPlaceCityState,
          'Birth Date': birthDateMoment.format("YYYY-MM-DD"),
          'Birth Time': birthDateTimeUnknown ? '' : birthDateMoment.format("hh:mmA"),
          //'daylight_saving_time': birthDateDst,
          'timezone_offset': birthDateMoment.format("Z"),
        });
  
        if (emailOptIn) {
          klaviyoSubscribe(q3.klaviyo.fye_list_id, email);
        }
      }
  
      // Maintain protocol, preview domain, and language directory
      const curUrl = window.location.href;
      const pagesUrl = curUrl.substring(0, curUrl.indexOf("/pages") + 6);
      const elementUrl = `${pagesUrl}/${fye.slug}?first_name=${firstName}`;
      //console.log("q3.quizForm.submit", { curUrl, pagesUrl, elementUrl });
      window.location.replace(elementUrl);
    });
  }

  q3.elementsPageVisibility = function() {
    const container = $(this);
    const bgGifs = container.find("[data-q3-epv-bg-gif]");
    const elementBlocks = container.find("[data-q3-epv-element-block]");
  
    const hoverIn = function() {
      const elementBlock = $(this);
      const elementGroup = elementBlock.data("q3-epv-element-block");
  
      bgGifs.each(function() {
        const item = $(this);
        const itemGroup = item.data("q3-epv-bg-gif");
        
        if (itemGroup === elementGroup) {
          item.addClass("show");
        }
      });
      
      elementBlocks.each(function() {
        const item = $(this);
        const itemGroup = item.data("q3-epv-element-block");
  
        if (itemGroup === elementGroup) {
          item.addClass("show");
          item.addClass("hover");
          item.find("[data-q3-epv-element-block-image]").removeClass("show");
        } else {
          item.removeClass("show");
        }
      });
    };
    
    const hoverOut = function() {
      bgGifs.removeClass("show");
      elementBlocks.find("[data-q3-epv-element-block-image]").addClass("show");
      elementBlocks.removeClass("hover");
      elementBlocks.addClass("show");
    };
  
    elementBlocks.hover(hoverIn, hoverOut);
  }

  q3.init = async function() {
    $("[data-q3-selects-time]").each(q3.selectsTime);
    $("[data-q3-quiz]").each(q3.quiz);
    $("[data-q3-epv]").each(q3.elementsPageVisibility);
    $("[data-q3-tab-container]").each(q3.tabContainer);
  };

  q3.init();
})();